import { Instagram, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

const LOGO_URL =
  "/logo.png";

export default function Footer() {
  const { t } = useT();
  return (
    <footer data-testid="footer" className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="The Sand Lab"
              className="h-14 w-auto brightness-0 invert"
            />
            <p className="mt-4 text-slate-400 text-sm max-w-md leading-relaxed">
              {t("footer_blurb")}
            </p>
            <div className="mt-6 flex gap-3">
              <SocialIcon
                href="https://www.instagram.com/the_sand_lab"
                icon={<Instagram className="h-4 w-4" />}
                testid="footer-ig"
                newTab
              />
              <SocialIcon
                href="tel:6980835933"
                icon={<Phone className="h-4 w-4" />}
                testid="footer-phone"
              />
            </div>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400 mb-4 font-semibold">
              {t("footer_explore")}
            </div>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li><a href="#home" className="hover:text-sunset">{t("nav_home")}</a></li>
              <li><a href="#contact" className="hover:text-sunset">{t("nav_contact")}</a></li>
              <li><a href="#faq" className="hover:text-sunset">{t("nav_faq")}</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-widest text-slate-400 mb-4 font-semibold">
              {t("footer_court")}
            </div>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>{t("footer_court_hours")}</li>
              <li>{t("footer_court_session")}</li>
              <li>{t("footer_court_net")}</li>
              <li><a href="tel:6980835933" className="hover:text-sunset" data-testid="footer-phone-text">698 083 5933</a></li>
              <li>
                <Link to="/admin" className="hover:text-sunset">
                  {t("footer_admin")}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>
            © {new Date().getFullYear()} The Sand Lab Beach Volleyball Academy. {t("footer_copy")}
          </span>
          <span>{t("footer_motto")} ☀</span>
        </div>
      </div>
    </footer>
  );
}

const SocialIcon = ({ href, icon, testid, newTab }) => (
  <a
    href={href}
    {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    data-testid={testid}
    className="h-10 w-10 rounded-full bg-white/5 hover:bg-sunset transition-colors flex items-center justify-center"
  >
    {icon}
  </a>
);
